import { render, staticRenderFns } from "./search_box.vue?vue&type=template&id=72d99688&scoped=true&"
import script from "./search_box.vue?vue&type=script&lang=js&"
export * from "./search_box.vue?vue&type=script&lang=js&"
import style0 from "./search_box.vue?vue&type=style&index=0&id=72d99688&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d99688",
  null
  
)

export default component.exports